import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  header: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    height: 72,
    paddingHorizontal: 32,
    justifyContent: 'space-between',
    borderBottomColor: '#EBEEEF',
    borderBottomWidth: 1,
    marginBottom: 12,
    backgroundColor: '#F4F9FD',
  },
  title: {
    fontWeight: '600',
    fontSize: 20,
    lineHeight: 30,
    color: '#003353',
  },
  closeButton: {
    width: 40,
    height: 40,
    backgroundColor: 'white',
    borderRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
    borderColor: '#E6EBEE',
    borderWidth: 1,
  },
})
